<template>
  <div class="curriculum">
  <div class="menu">
    <li v-for="(item, index) in items" :key=index>
      <span v-on:click="renderContent(item.contents)"> {{item.name}} </span>
    </li>
    </div>
    <div class="content">
      <div v-for="(content, index) in displayedContent" :key=index class="content-block">
         <h4 v-if=content.headline>{{content.headline}}</h4>
        <li v-for="(text, index) in content.texts" :key=index>
          {{text}}
        </li>
      </div>
    </div>
  </div>
</template>

<script>
import CV from '../data/CV.js'
import PDF from '../data/PDF.js'

export default {
  name: 'Curriculum',
  data () {
    return {
      displayedContent: [],
      items: []
    }
  },
  created () {
    this.items = CV.get()
  },
  methods: {
    renderContent (content) {
      if (content[0].downloadLink === undefined) {
        this.displayedContent = content
      } else {
        PDF.download(content[0].downloadLink)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../assets/styles/_variables.scss';

h4 {
  margin-bottom: 0.2em;
  margin-top: 0em;
}
.curriculum {
  margin-top:50px;
}
.menu{
  float:left;
}
.menu > li {
  margin-bottom: 15px;
  text-align: left;
  list-style: none;
  cursor: pointer;
}
.menu > li:hover {
  border-bottom: 2px solid $acc-color;
  margin-bottom: 13px;
}
.content {
    float: right;
    width: 490px;
    text-align: left;
    display: block;
    /* overflow: scroll; */
    max-height: 330px;
    scroll-behavior: smooth;
    overflow-y: auto;
    overflow-x: hidden;
    font-size: 0.9em;
}
.content-block{
  margin-bottom: 0.4em;
}
a {
  color: $acc-color;
}
</style>
